import BackupUser from "../backup/backup.user";

const DbUser = () => <BackupUser backupKind="db" />;

export default DbUser;
